/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Movement_Breakdown_Clear_SelectionInputs */

const vi_movement_breakdown_clear_selection = /** @type {(inputs: Movement_Breakdown_Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bỏ chọn tất cả`)
};

/**

* @param {Movement_Breakdown_Clear_SelectionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const movement_breakdown_clear_selection = /** @type {((inputs?: Movement_Breakdown_Clear_SelectionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Movement_Breakdown_Clear_SelectionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_movement_breakdown_clear_selection(inputs)
});